import BaseClass from "../BaseClass.js";

export default class CheckboxSwitch extends BaseClass {

    constructor(element) {
        super(element);

        this.url = null;
        this.postName = null;
        this.confirm = null;
        this.$replaceElement = null;
        this.init();
    }

    init() {
        let url = this.$element.data('url');
        if (url != undefined && url.length > 0) {
            this.url = url;
        }
        let postName = this.$element.attr('name');
        if (postName != undefined && postName.length > 0) {
            this.postName = postName;
        }
        let confirm = this.$element.data('confirm');
        if (confirm != undefined && confirm.length > 0) {
            this.confirm = confirm;
        }

        let replaceElementId = this.$element.data('replace-element');
        if (replaceElementId != undefined) {
            let $replaceElement = $('#' + replaceElementId);
            if ($replaceElement.length == 1) {
                this.$replaceElement = $replaceElement;
            }
        }

        let mySelf = this;
        this.changeListener = function () {
            if (mySelf.confirm != null) {
                setTimeout(function () {
                        mySelf.sendConfirm();
                    }, 100
                );
            } else {
                mySelf.sendData();
            }
        };
        this.$element.on('change', this.changeListener);
    }

    /**
     * Sendet Post Request mit Inhalt der Checkbox
     */
    sendData() {
        const mySelf = this;
        let postData = this.$element.attr('data-post-data');

        if (undefined == postData || 0 == postData.length) {
            postData = '';
        } else {
            postData += '&';
        }

        if (mySelf.element.checked) {
            postData += mySelf.postName + '=' + mySelf.$element.val();
        } else {
            postData += mySelf.postName + '=0';
        }

        let jqxhr = $.post(this.url, postData, function (response) {
            mySelf.handleAjaxResponse(response);
        }, 'json')
            .fail(function (response) {
                // checkbox zurücksetzen
                if (mySelf.element.checked) {
                    mySelf.$element.prop('checked', false);
                } else {
                    mySelf.$element.prop('checked', true);
                }
            });
    }

    sendConfirm() {
        if (confirm(this.confirm)) {
            this.sendData();
        } else {
            // checkbox zurücksetzen
            if (this.element.checked) {
                this.$element.prop('checked', false);
            } else {
                this.$element.prop('checked', true);
            }
        }
    }

    addErrorContainer(errorName, errorString) {
        let $errorContainer = this.templatesWorker.getTemplate('form_validation_error_tpl');
        $errorContainer.attr('for', errorName);
        $errorContainer.find('[data-type="message"]').html(errorString);

        this.after($errorContainer);

        this.on('click', function () {
            $errorContainer.remove();
        });
        $errorContainer.on('click', function () {
            $errorContainer.remove();
        });
    }

    destroyListener() {
        this.$element.off('change', this.changeListener);
    }
}